import { getButtonSizesMixin, buttonSizes, buttonTypography } from '@sberdevices/plasma-core';

export const applySizes = getButtonSizesMixin(buttonSizes, buttonTypography);
